import React from "react";
import { connect } from "react-redux";
import { Form, Col } from 'react-bootstrap';
import PropTypes from "prop-types";

import ConditionalButton from "../../layout/conditional-button";
import { deepEqual } from "../../utils/object";
import Personal from "./person";
import CsLineIcons from "../../cs-line-icons";

import { pack as setAlerts } from "../../actions/alert";

class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            person: { ...this.props?.auth?.user?.Person }
        };
        
    }

    componentDidUpdate = (oldProps) => {
        if (!deepEqual(this.props.auth.user.Person, this.state.person)) {
            this.setState({
                person: this.props.auth.user.Person
            });
        }
    }

    componentDidMount = async () => {
        
    }

    onPersonChange = (value, errors) => {
        this.setState({
            ...this.state,
            person: {
                ...value
            },
            errors: errors
        });
    }

    onSaveClick = async (e) => {
    }

    onShowErrors = (e) => {
        const __messages = [];
        this.state.errors.forEach((error) => {
            __messages.push(error.errors[0]);
        })
        this.props.setAlerts(__messages, "error");
    }

    render() {
        return (
            <>
                <Col xs="12" className="licensee-editor-toolbar">
                    <ConditionalButton className="licensee-save-button" enabledVariant="primary" tooltip="Save my information" display={true} enabled={true} onEnabledClick={this.onSaveClick} icon="check-square">Save Changes</ConditionalButton>
                </Col>
                <Col xs="12" className="licensee-editor">
                    <Form name="frm" action="post" onSubmit={this.onSubmit} >
                        <Personal {...this.state.person} onChange={this.onPersonChange} />
                    </Form>
                    <aside className="licensee-security-note">
                        <CsLineIcons icon="lock-on" size="24" />
                        <span><strong>Your information is secure</strong><small>We use industry-standard security to protect your personal information.</small></span>
                    </aside>
                </Col>
            </>
        )
    }
}

Profile.propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object,
    person: PropTypes.object,
    fields: PropTypes.array,
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth,
        profile: state.licensee.profile,
        fields: state.fields.items
    });
};

export default connect(mapStateToProps, { setAlerts })(Profile);
